import { render, staticRenderFns } from "./textPractice.vue?vue&type=template&id=629e6942&scoped=true&"
import script from "./textPractice.js?vue&type=script&lang=js&"
export * from "./textPractice.js?vue&type=script&lang=js&"
import style0 from "./textPractice.css?vue&type=style&index=0&id=629e6942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e6942",
  null
  
)

export default component.exports